// extracted by mini-css-extract-plugin
export default {"touch":"_1I4x1EN9H_isesoff_AIny borderRadius-circle","pulse":"_1P5fiB7uCePbId0yhhTUI7"};